import { ML_SCAN } from '../constant/actionTypes';

const getMLScanList = (state, action) => {
  switch (action.type) {
    case ML_SCAN.GET.INITIATE:
      return { isFetching: true };
    case ML_SCAN.GET.SUCCESS:
      return { isFetching: false, data: action.payload };
    case ML_SCAN.GET.ERROR:
      return { isFetching: false, data: action.payload };
    default:
      return (typeof state === 'undefined') ? [] : state;
  }
};

export default getMLScanList;
